import { useEffect } from 'react';
import { Stage } from './frames/Device';
import { ControlPanel } from './shell/ControlPanel';
import { writeHash } from './shell/presets';
import { getState, useStore } from './state/store';

export function App() {
  const mode = useStore((s) => s.mode);
  const layout = useStore((s) => s.layout);
  const org = useStore((s) => s.orgId);
  const landscape = useStore((s) => s.landscape);
  const split = useStore((s) => s.split);
  const stage = useStore((s) => s.auth.stage);

  useEffect(() => {
    document.documentElement.dataset.mode = mode;
  }, [mode]);

  useEffect(() => {
    writeHash(getState());
  }, [mode, layout, org, landscape, split, stage]);

  return (
    <div className="prototype">
      <ControlPanel />
      <Stage />
    </div>
  );
}
